import { OnInit } from '@angular/core';
var ResendEmailVerificationComponent = /** @class */ (function () {
    function ResendEmailVerificationComponent() {
    }
    ResendEmailVerificationComponent.prototype.ngOnInit = function () {
    };
    return ResendEmailVerificationComponent;
}());
export { ResendEmailVerificationComponent };
